import React, {useEffect, useState} from 'react';
import {HttpStatus} from "../../../../modules/common/enums/HttpStatus";
import {FormattedMessage, useIntl} from "react-intl";
import {PaginationDto} from "../../../../modules/common/dto/PaginationDto";
import {RequestVisitorSearchCondition} from "../../../../modules/vms/dto/RequestVisitorSearchCondition";
import {RequestVisitorApi} from "../../../../modules/vms/api/RequestVisitorApi";
import {RequestVisitorDto} from "../../../../modules/vms/dto/RequestVisitorDto";
import NavigationBar from "../../../../components/NavigationBar";
import HomeIcon from "@mui/icons-material/Home";
import {RoutePath} from "../../../../constants/RoutePath";
import {useNavigate} from "react-router-dom";
import MyVisitorDetailCard from './components/MyVisitorDetailCard';
import {Button} from "@mui/material";
import {MessageUtils} from "../../../../utils/MessageUtils";
import {HttpUtils} from "../../../../utils/HttpUtils";
import {WeChatAuthApi} from "../../../../modules/wechat/api/WeChatAuthApi";

const Index: React.FC = () => {

    const intl = useIntl();
    const navigate = useNavigate();

    // 查询条件
    const [searchCondition, setSearchCondition] = useState(new RequestVisitorSearchCondition());

    // 查询结果
    const [searchResult, setSearchResult] = useState(new Array<RequestVisitorDto>());

    // 分页数据
    const [pagination, setPagination] = useState(new PaginationDto());
    const [wechatOpenId, setWechatOpenId] = useState("");

    useEffect(() => {
        // 微信网页授权会携带code，然后通过后台获取openID，提交的时候把该openID跟访客绑定
        const wxOAuthCode = HttpUtils.getQueryString(window.location.href, "wxOAuthCode");
        if (wxOAuthCode) {
            _handleGetWeChatOpenId(wxOAuthCode);
        }
    }, []);

    const _handleGetWeChatOpenId = async (wxOAuthCode: string) => {
        const responseResult = await WeChatAuthApi.getOAuth2AccessToken(wxOAuthCode);
        if (responseResult.status === HttpStatus.SUCCESS) {
            setWechatOpenId(responseResult.data.openid);
            searchCondition.wxOpenId = responseResult.data.openid;
            setSearchCondition(searchCondition);
            _handleSearch(searchCondition);
        }
    }

    const _handleSearch = async (searchCondition: RequestVisitorSearchCondition) => {
        const responseResult = await RequestVisitorApi.queryMyCreate(searchCondition);
        if (responseResult.status === HttpStatus.SUCCESS) {
            const responseVisitors = Object.assign([], responseResult.data);
            const newVisitors = Object.assign([], searchResult);
            setSearchResult(newVisitors.concat(responseVisitors));
            setPagination(responseResult.pagination);
        }
    };

    const _handleResearch = async (searchCondition: RequestVisitorSearchCondition) => {
        const responseResult = await RequestVisitorApi.queryMyCreate(searchCondition);
        if (responseResult.status === HttpStatus.SUCCESS) {
            setSearchResult(responseResult.data);
            setPagination(responseResult.pagination);
        }
    };

    const _handlePagination = () => {
        if (pagination.pageSum > pagination.currentPage) {
            searchCondition.currentPage = pagination.currentPage + 1;
            searchCondition.pageSize = pagination.pageSize;
            _handleSearch(searchCondition);
        } else {
            MessageUtils.warning(intl.formatMessage({id: "COMMON_LOAD_MORE_NONE"}));
        }
    };

    return (
        <div>
            <NavigationBar leftIcon={<HomeIcon/>}
                           leftIconClick={() => navigate(RoutePath.VMS_MOBILE_WELCOME)}
                           title={intl.formatMessage({id: "VMS_REQUEST_VISITOR_HISTORY_LIST"})}/>
            <div style={{padding: "1rem"}}>
                {
                    searchResult.map((requestVisitor, index) => {
                        return (
                            <div key={index} style={{marginBottom: "1rem"}}>
                                <MyVisitorDetailCard visitRequest={requestVisitor.visitRequest}
                                                     requestVisitor={requestVisitor}
                                                     onRefresh={() => _handleResearch(searchCondition)}/>
                            </div>
                        )
                    })
                }
                <Button fullWidth={true}
                        variant="contained"
                        onClick={() => _handlePagination()}>
                    <FormattedMessage id={'COMMON_LOAD_MORE'}/>
                </Button>
            </div>
        </div>
    );
};

export default Index;
